import * as React from 'react';
import { Layout, LayoutProps } from 'react-admin';
import Menu from './Menu';

const LayoutWrapper: React.FC = (props: LayoutProps) => (
    <Layout {...props} menu={Menu} />
);

export default LayoutWrapper;
